import { useData } from '@/components';
import { ProductCardSlice } from 'prismicio-types';

type ActiveAndLargeSlice = {
  activeProduct?: ProductCardSlice;
  isLargeCard: boolean;
  spaceBetween: 'none' | 'small' | 'medium' | 'large';
};

const useActiveProductSlice = (): ActiveAndLargeSlice => {
  const { productCard } = useData();

  const slices = productCard?.slices || [];

  const activeProduct = slices.find(
    (s: ProductCardSlice) => s?.primary?.active,
  );

  const isLargeCard =
    productCard?.product_card_large ||
    activeProduct?.variation === 'productCardLarge';

  const spaceBetween = productCard?.spacing_between_card;

  return { activeProduct, isLargeCard, spaceBetween };
};

export { useActiveProductSlice };
